export const locationRoutes = {
  getLocationsByName: '/api/v1/location/search',
  setNewLocation: '/api/v1/location/new',
  updateLocation: '/api/v1/location/:locationId/update',
  deleteLocation: '/api/v1/location/:locationId/deactivate',
}
